 
export const trackerTooltips = {
  mainGrid: {
    columns: {
      ranks_trand: (
        <>
          توی این بخش حداکثر ۱۰ رتبه آخر رو می‌بینی. ستون "روند رتبه" هم برای
          تحلیل سریع به درد می‌خوره، مخصوصاً اگه کلماتت زیاد باشه. دقت کن که
          تغییر بازه زمانی می‌تونه روی این ستون تاثیر بذاره.
        </>
      ),
      best_rank: (
        <>
          بهترین رتبه‌ای که این کلمه توی بازه زمانی داشته رو نشون می‌ده. هرچی
          عدد به ۱ نزدیک‌تر باشه، بهتره.
        </>
      ),
      worst_rank: (
        <>
          بدترین رتبه‌ای که این کلمه توی بازه زمانی داشته رو نشون می‌ده. هرچی
          عدد به ۱۰۰ نزدیک‌تر باشه، بدتره.
        </>
      ),
      have_cannibal: (
        <>
          مشکلات مربوط به کنیبالیزیشن یا همنوع‌خواری بر اساس آخرین بروزرسانی
          رتبه مشخص می‌شن. اگه مشکلی باشه، آیکون کنیبالیزیشن یا همنوع‌خواری
          نمایش داده می‌شه. با کلیک روی آیکون، می‌تونید جزئیات بیشتری از مشکل رو
          ببینید.
        </>
      ),
      first_rank: (
        <>
          اولین رتبه‌ای که این کلمه توی کل بازه در ابزار میزفا تولز داشته رو
          نشون می‌ده. این رتبه با تغییر بازه زمانی عوض نمی‌شه و همیشه یک عدد
          ثابت هست.
        </>
      ),
      previous_rank: (
        <>
          "رتبه قبلی" به رتبه‌ای گفته می‌شه که یکی قبل از رتبه فعلی در همون بازه
          زمانی باشه. در واقع، رتبه‌ایه که قبل از رتبه فعلی ثبت شده.
        </>
      ),
      average_rank: (
        <>
          "رتبه میانگین" به میانگین رتبه‌های کلمه در بازه زمانی انتخاب شده گفته
          میشه.
        </>
      ),
      preiod_rank: (
        <>
          "رتبه ابتدای بازه" اولین رتبه‌ای که این کلمه توی بازه زمانی داشته رو
          نشون می‌ده.
        </>
      ),
      change_preiod_rank: (
        <div className="text-start">
          اگه توجه داشته باشید، در میزفا تولز یک "رتبه ابتدای بازه" هم داریم.
          تغییر "رتبه فعلی" یک کلمه نسبت به "رتبه ابتدای بازه" میشه "تغییر رتبه
          ابتدای بازه". اگه رتبه شما "ورود" یا "خروج" بود، و به دنبال اطلاعات
          بیشتر بودی، روی لینک{' '}
          <a
            href="https://help.mizfa.tools/keywords-input-and-output-changes/"
            target="_blank"
            rel="noreferrer noopener"
            className="text-primary"
          >
            تغییر ورود و خروج{' '}
          </a>{' '}
          کلیک کن.
        </div>
      ),
      have_conflict_with_landing_url: (
        <>
          اگه توی کلمه کلیدی X، صفحه هدف با صفحه‌ای که پیدا شده یکی نباشه، یعنی
          یه مشکلی هست 😕. یا به عبارتی، این بخش از سایت خوب سئو نشده، چون
          می‌خواستیم صفحه Z بالا بیاد ولی صفحه Y اومده. پیشنهاد می‌کنم حتماً{' '}
          <a
            href="https://help.mizfa.tools/reasons-for-inconsistency-with-landing-page/"
            target="_blank"
            rel="noreferrer noopener"
            className="text-primary"
          >
            این لینک
          </a>{' '}
          رو مطالعه کنید. اگر شما در این ستون چیزی مشاهده نکردید دو علت داره، یا
          صفحه هدف مشخص نکردید و یا اگر صفحه هدف مشخص کردید خداروشکر مشکل مغایرت
          ندارید.
        </>
      ),
      title: (
        <>
          کلمه کلیدی عبارتی هست که کاربران جستجو میکنن تا به نیازهای خودشون در
          گوگل برسن، حال اگر کسب و کار شما راهگشای این نیازها هست باید سعی کنید
          در جهت حفظ منافع کاربر و کسب و کارتون، سایتتون در رتبه های برتر گوگل
          نمایش داده بشه.
        </>
      ),
      rank: (
        <>
          اخرین رتبه سایتت رو در هر کلمه کلیدی مشاهده میکنی. توجه داشته باش که
          رتبه ها در گوگل اصولا نوسان دارن.
        </>
      ),
      change_rank: (
        <div className="text-start">
          تغییر رتبه یعنی مقایسه رتبه فعلی با رتبه قبلی در بازه زمانی
          انتخاب‌شده. به طور ساده، این ستون نشون می‌ده رتبه فعلی چقدر نسبت به
          قبلی تغییر کرده. برای اطلاعات بیشتر در مورد تغییر رتبه، می‌تونی{' '}
          <a
            href="https://help.mizfa.tools/keywords-changes-to/"
            target="_blank"
            rel="noreferrer noopener"
            className="text-primary"
          >
            این لینک{' '}
          </a>{' '}
          رو چک کنی. اگه رتبه شما "ورود" یا "خروج" بود، و به دنبال اطلاعات بیشتر
          بودی، روی لینک{' '}
          <a
            href="https://help.mizfa.tools/keywords-input-and-output-changes/"
            target="_blank"
            rel="noreferrer noopener"
            className="text-primary"
          >
            تغییر ورود و خروج{' '}
          </a>{' '}
          کلیک کن.
        </div>
      ),
      change_average_rank: (
        <div className="text-start">
          اگه توجه داشته باشید، در میزفا تولز یک "رتبه میانگین" هم داریم. تغییر
          "رتبه فعلی" یک کلمه نسبت به "رتبه میانگین" در بازه انتخاب شده، میشه
          "تغییر میانگین". اگه رتبه شما "ورود" یا "خروج" بود، و به دنبال اطلاعات
          بیشتر بودی، روی لینک{' '}
          <a
            href="https://help.mizfa.tools/keywords-input-and-output-changes/"
            target="_blank"
            rel="noreferrer noopener"
            className="text-primary"
          >
            تغییر ورود و خروج{' '}
          </a>{' '}
          کلیک کن.
        </div>
      ),
      change_first_rank: (
        <div className="text-start">
          اگه توجه داشته باشید، در میزفا تولز یک "رتبه ابتدا" هم داریم. تغییر
          "رتبه فعلی" یک کلمه نسبت به "رتبه ابتدا" میشه "تغییر ابتدا". اگه رتبه
          شما "ورود" یا "خروج" بود، و به دنبال اطلاعات بیشتر بودی، روی لینک{' '}
          <a
            href="https://help.mizfa.tools/keywords-input-and-output-changes/"
            target="_blank"
            rel="noreferrer noopener"
            className="text-primary"
          >
            تغییر ورود و خروج{' '}
          </a>{' '}
          کلیک کن.
        </div>
      ),
      found_url: (
        <>
          صفحه پیدا شده صفحه ی از سایت شما در گوگل هست که در حال حاضر در آن با
          کلمه کلیدی مورد نظر رتبه داری.
        </>
      ),
      group_title: (
        <div className="text-start">
          برای دسته‌بندی کلمات، می‌تونی از دسته‌بندی‌ها استفاده کنی. مثلاً اگر
          فروشگاه لوازم دیجیتال داری، دسته‌های "موبایل سامسونگ" و "موبایل هوآوی"
          می‌تونن انتخاب‌های خوبی برای نظم دادن به کلماتت باشن. با این کار،
          تحلیل کردن خیلی راحت‌تر می‌شه. راهنمای مربوط به دسته‌بندی رو می‌تونی
          در{' '}
          <a
            href="https://help.mizfa.tools/category/mizfa-tracker-pro/topic-keyword/"
            target="_blank"
            rel="noreferrer noopener"
            className="text-primary"
          >
            این لینک
          </a>{' '}
          مشاهده کنی. درضمن برای ساخت دسته باید وارد تب دسته بشی و در اونجا
          میتونی آمارهای خوبی از هر دسته رو مشاهده کنی.
        </div>
      ),
      tags: (
        <div className="text-start">
          حرفه‌ای‌ها از برچسب استفاده میکنن. به‌عنوان مثال با استفاده از برچسب
          می‌تونی همه کلمات کلیدی رو در سه سطح تقسیم‌بندی کنی: اولویت مهم،
          اولویت متوسط و اولویت ضعیف. با این کار، می‌تونی به کارهات در سئو نظم
          بیشتری بدی. حتماً نمونه برچسب‌های کاربردی رو در{' '}
          <a
            href="https://help.mizfa.tools/functional-labels/"
            target="_blank"
            rel="noreferrer noopener"
            className="text-primary"
          >
            این لینک
          </a>{' '}
          مطالعه کن. درضمن برای ساخت برچسب باید وارد تب برچسب بشی و در اونجا
          میتونی آمارهای خوبی از هر برچسب رو مشاهده کنی.
        </div>
      ),
      inserted_at: (
        <>
          تاریخ درج به شما تاریخی رو نمایش میده که شما برای اولین بار کلمه کلیدی
          رو درج کردی و این تاریخ بهت کمک میکنه تا متوجه بشی از زمان درج تا الان
          چیکار کردی.
        </>
      ),
      updated_at: (
        <>
          تاریخ به‌روزرسانی با هر بار به‌روزرسانی کلمه کلیدی تغییر میکنه. مقایسه
          رتبه کلمه کلیدی در تاریخ درج و تاریخ به‌روزرسانی به شما کمک خوبی در
          سئو میکنه.
        </>
      ),
      landing_url: (
        <>
          صفحه هدف دقیقا همون صفحه ای هست که قصد داری کلمه کلیدیت در اون صفحه
          رتبه کسب کنه یا به عبارتی جرء ده نتیجه اول گوگل باشه. صفحه هدف رو باید
          خودت مشخص کنی و اگر صفحه هدف مشخص شده توسط شما با صفحه پیدا شده یکی
          باشه یعنی به هدفی که میخواستی رسیدی و اگر برعکس باشه میتونه مشکل ساز
          بشه و به کمک میزفا تولز میتونی این موارد رو با یک مقایسه ساده و به
          راحتی متوجه بشی.
        </>
      ),
      result_count: (
        <>
          تعداد نتایج یا Indexed Pages همان تعداد result های داخل نتایج گوگل
          می‌باشد. عدد بالا نشان دهنده تعداد مطالب بیشتر درباره آن موضوع هست.
        </>
      ),
      ads_avg_search_volume: (
        <>
          Search Volume - ‌میانگین تعداد جستجوی ماهانه آن کلمه - مقادیر این ستون
          از گوگل اذر گرفته شده.
        </>
      ),
      snippets: <>SERP Features</>,
      snipptetsTooltip: {
        people_also_ask:
          'در نتایج گوگل این کلمه کلیدی سوالات متداول گوگل (people also ask) موجود هست.',
        recipes:
          'در نتایج گوگل این کلمه کلیدی دستور آشپزی (recipes) موجود هست.',
        shopping: 'در نتایج گوگل این کلمه کلیدی فروشگاه (shopping) موجود هست.',
        links: 'در نتایج گوگل این کلمه کلیدی site link موجود هست.',
        top_stories: 'در نتایج گوگل این کلمه کلیدی top story موجود هست.',
        twitter: 'در نتایج گوگل این کلمه کلیدی twitter موجود هست.',
        video: 'در نتایج گوگل این کلمه کلیدی چند ویدیو موجود هست.',
        amp_version: 'در نتایج گوگل این کلمه کلیدی صفحات amp موجود هست.',
        answer_box: 'در نتایج گوگل این کلمه کلیدی answer box موجود هست.',
        app: 'در نتایج گوگل این کلمه کلیدی app موجود هست.',
        carousel: 'در نتایج گوگل این کلمه کلیدی carousel موجود هست.',
        faq: 'در نتایج گوگل این کلمه کلیدی یک و یا چند سایت faq دارند.',
        featured_snippet:
          'در نتایج گوگل این کلمه کلیدی featured snippet موجود هست.',
        images: 'در نتایج گوگل این کلمه کلیدی چندین تصویر موجود هست.',
        knowledge_graph:
          'در نتایج گوگل این کلمه کلیدی graph knowledge موجود هست.',
        local_pack: 'در نتایج گوگل این کلمه کلیدی pack local موجود هست.',
        paid: 'در نتایج گوگل این کلمه کلیدی تبلیغات گوگل (Ads) موجود هست.',
        raiting: 'در نتایج گوگل این کلمه کلیدی یک و یا چند سایت ستاره دارند.'
      },
      ads_competition: (
        <>
          Competition - رقابتی بودن هر کلمه کلیدی را از ۰ تا ۱۰۰ نشان می‌دهد و
          هر چه به ۱۰۰ نزدیک تر باشد رقابتی تر هست. - مقادیر این ستون از گوگل
          ادز گرفته شده
        </>
      ),
      mizfa_tools_search_volume: (
        <>
          میزان تعداد جستجوی ماهانه (Avg.ESV) که توسط ابزار میزفا تولز محاسبه
          شده است.
        </>
      ),
      length: (
        <>
          طول هر کلمه کلیدی چقدر هست؟ مثلا "قیمت موبایل" از دو کلمه تشکیل شده،
          اصولا هر چی طول کلمه کمتر باشه رقابت در اون کلمه کلیدی بیشتره و هر چی
          طول کلمه بیشتر باشه رقابت کمتره و راحتتر میتونی در اون کلمه رتبه
          بگیری. شما میتونی با مرتب کردن براساس طول بررسی کنی و ببینی وضعیت رتبه
          کلمات کلیدی پررقابت و کم‌رقابت سایتت به چه صورت هست.
        </>
      )
    },
    noRank: (
      <div className="text-start">
        سایت شما در این کلمه کلیدی جایگاهی در نتایج گوگل نداره ، یا اصلا روی این
        کلمه کار نکردی، یا خوب سئو نکردی، یا افت رتبه داشتی، یا سایت تازه تاسیس
        هست، یا کلمه کلیدی مناسبی رو انتخاب نکردی و یا آدرس سایتت اشتباه هست.
        <br />
        <a
          href="https://help.mizfa.tools/faq/no-ranking-in-google-results/"
          target="_blank"
          rel="noreferrer noopener"
          className="text-primary"
        >
          (اطلاعات بیشتر)
        </a>
      </div>
    ),
    noRankInFirstPage: (
      <div className="text-start">
        سایت شما در این کلمه کلیدی جایگاهی در صفحه اول نتایج گوگل نداره ، یا اصلا روی این
        کلمه کار نکردی، یا خوب سئو نکردی، یا افت رتبه داشتی، یا سایت تازه تاسیس
        هست، یا کلمه کلیدی مناسبی رو انتخاب نکردی و یا آدرس سایتت اشتباه هست.
        <br />
        <a
          href="https://help.mizfa.tools/faq/no-ranking-in-google-results/"
          target="_blank"
          rel="noreferrer noopener"
          className="text-primary"
        >
          (اطلاعات بیشتر)
        </a>
      </div>
    ),
    noChecked: 'جهت مشاهده اطلاعات کلمه کلیدی روی دکمه به‌روزرسانی کلیک کن',
    noTags: 'برای این کلمه کلیدی برچسب انتخاب نکردی.',
    noGroups: 'برای این کلمه کلیدی دسته انتخاب نکردی.',
    noResOnPhones: 'تعداد نتایج در گوشی نمایش داده نمیشه.',
    googleResultHistory: 'سابقه نتایج گوگل',
    ranksHistory: 'سابقه رتبه',
    relatedKeywords: 'کلمات مرتبط',
    addDescription: 'افزودن توضیحات',
    lineProgress: 'نمودار روند رتبه',
    noSnippets: 'جهت مشاهده ویژگی نتایج این کلمه کلیدی را به‌روز کن.',
    noAds:
      'این داده بعد از ثبت نام به صورت خودکار بین ۲۴ تا ۴۸ ساعت به‌روز میشه.'
  },
  addKeywords: {
    deviceType: (
      <div className="text-start">
        به کمک این بخش تنظیم می‌کنید که کلمات بالا در رایانه (دسکتاپ) یا در گوشی
        (موبایل) جستجو بشن. توجه مهم: وقتی هر دو حالت رو انتخاب کنید هر کلمه دو
        بار در پنل اضافه میشه، جهت اطلاعات بیشتر{' '}
        <a
          href="https://help.mizfa.tools/add-keyword/"
          target="_blank"
          rel="noreferrer noopener"
          className="text-primary"
        >
          این لینک
        </a>{' '}
        رو مطالعه کنید.
      </div>
    )
  }
};
